import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { usePageMeta } from '../hooks/usePageMeta';

const SECTIONS = [
  {
    heading: 'Why we exist',
    paragraphs: [
      'Health advice online is everywhere, and much of it is confusing, extreme or selling something. We wanted one calm place that explains what matters most, in plain language, and helps you take one small step at a time.',
    ],
  },
  {
    heading: 'How the site works',
    bullets: [
      'Start with the Essentials: the everyday habits that matter most.',
      'Explore Areas of Life: every part of daily wellbeing, from body and mind to work, money and relationships.',
      'Dive into the Library: practical guides on specific topics.',
      'Build Everyday Habits: a free personal space to set priorities and track small routines.',
    ],
  },
  {
    heading: 'Who writes our guides',
    paragraphs: [
      'Our guides are written by the OVERALL WELLBEING Editorial Team. We are writers and editors, not doctors, and we do not give medical advice. Every guide is based on official and trusted sources, such as the World Health Organization, ICMR–National Institute of Nutrition and India’s Ministry of Health, and we link those sources on the page. You can read how we work in our Editorial Standards (/editorial-standards).',
    ],
  },
  {
    heading: 'Our promises',
    bullets: [
      'Independent: no sponsored content, and no paid product recommendations.',
      'Private: we never sell your data. See our Privacy Policy (/privacy).',
      'Guidance, not diagnosis: we help you understand and act; your doctor diagnoses and treats.',
    ],
    after: 'OVERALL WELLBEING is published by Mediatine Adscale Private Limited, New Delhi, India. Questions or ideas? Contact us (/contact).',
  },
];

export default function About() {
  usePageMeta({
    title: 'About OVERALL WELLBEING',
    description:
      'A free, independent guide to everyday wellbeing: who we are, how the site works and what we promise.',
    path: '/about',
  });

  return (
    <LegalLayout
      testId="about-page"
      eyebrow="Who we are"
      title="About OVERALL WELLBEING"
      intro="OVERALL WELLBEING is a free, independent guide to everyday wellbeing. It turns trusted health guidance into simple habits you can fit into a real Indian day: better sleep, home-style eating, more movement, calmer days and stronger relationships."
      sections={SECTIONS}
    />
  );
}
